// School domain types -- iteration 066 (unified model)

import type { SchoolTypePublic } from "./school-type.js";

// API response types

export interface SchoolPublic {
  id: string;
  slug: string;
  school_type_id: string | null;
  school_type: SchoolTypePublic | null;
  emis_number: string | null;
  name: string;
  display_name: string | null;
  abbreviation: string | null;
  province: string | null;
  town: string | null;
  phase: string | null;
  sector: string | null;
  specialization: string | null;
  status: string | null;
  quintile: number | null;
  no_fee_school: boolean | null;
  district: string | null;
  circuit: string | null;
  suburb: string | null;
  street_address: string | null;
  postal_address: string | null;
  telephone: string | null;
  learner_count: number | null;
  educator_count: number | null;
  website_url: string | null;
  google_place_id: string | null;
  location: string | null;
  latitude: number | null;
  longitude: number | null;
  is_imported: boolean;
  logo_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  is_affiliated: boolean; // true if linked to user's org via OrganizationSchool
  // 131 Schools-as-Venues
  venue_type: VenueType;
  verified: boolean;
  added_by_school_id: string | null;
  created_at: string;
  updated_at: string;
  _actions: SchoolAction[];
}

export type SchoolAction = "view" | "edit" | "delete" | "affiliate" | "unaffiliate" | "verify";

// 131 -- the schools table doubles as the venue table.
export const VENUE_TYPES = ["school", "club", "university", "stadium", "sports_facility"] as const;
export type VenueType = (typeof VENUE_TYPES)[number];

export interface AddVenueInput {
  name: string;
  venue_type: VenueType;
  google_place_id?: string | null;
  location?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  abbreviation?: string | null;
  town?: string | null;
  province?: string | null;
}

export interface PendingVenuesResponse {
  venues: SchoolPublic[];
}

export interface SchoolListResponse {
  schools: SchoolPublic[];
}

export interface SchoolResponse {
  school: SchoolPublic;
}

// OrganizationSchool types

export interface OrganizationSchoolPublic {
  organization_id: string;
  school_id: string;
  school_name: string;
}

// SchoolPlayer types

export interface SchoolPlayerPublic {
  player_id: string;
  school_id: string;
  school_name: string;
  enrolled_from: string;
  enrolled_to: string | null;
  is_current: boolean;
}

export interface SchoolPlayerListResponse {
  enrollments: SchoolPlayerPublic[];
}
